// extracted by mini-css-extract-plugin
export default {"notfound":"pagenotfound_notfound__vkAS8","btn":"pagenotfound_btn__0cAza","custome_row":"pagenotfound_custome_row__iguiV"};